import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tab } from '@mercai/clever'

import {
  ProfileCreditFormGeneral,
  ProfileCreditFormDocuments,
} from './components'

import { ProfileCreditFormProps } from './profile-credit-form.type'
import styles from './profile-credit-form.module.css'

export const ProfileCreditForm = ({
  onHandleOpen,
  profileUuid,
  onSuccessUpdated,
  financeProfileData,
}: ProfileCreditFormProps) => {
  const { t } = useTranslation('componentOrderCenterForm')

  const [tab, setTab] = useState<'general' | 'documents'>('general')

  const tabsContent = {
    general: (
      <ProfileCreditFormGeneral
        onHandleOpen={onHandleOpen}
        profileUuid={profileUuid}
        onSuccessUpdated={onSuccessUpdated}
        financeProfileData={financeProfileData}
      />
    ),
    documents: (
      <ProfileCreditFormDocuments
        onHandleOpen={onHandleOpen}
        profileUuid={profileUuid}
        onSuccessUpdated={onSuccessUpdated}
        financeProfileData={financeProfileData}
      />
    ),
  } as const

  return (
    <div className={styles.core}>
      <div className={styles['custom-tabs']}>
        <Tab
          items={[
            {
              label: 'Información General',
              value: 'general',
            },
            {
              label: t('financeTabDocuments'),
              value: 'documents',
            },
          ]}
          onChange={(value) => setTab(value as typeof tab)}
          value={tab}
        />
      </div>

      {tabsContent[tab]}
    </div>
  )
}
